{
	"FileUploadInsertButton_tooltip": "Add a file",
	"FileUploadSettings_Header": "File",
	"FileUploadPlugin_Settings_FullPDFViewer_SubText": "Visitors can easily scroll down through your PDF and zoom in or out. We recommend this layout for mobile.",
	"FileUploadPlugin_Settings_MiniPDFViewer_SubText": "Visitors can browse through your file one page at a time.",
	"FileUploadPlugin_Settings_PDFDisplayOptions": "PDF display options",
	"FileUploadPlugin_Settings_EnablePDFViewer_Label": "Show PDF Viewer",
	"FileUploadPlugin_Settings_ShowPrintPDF_Label": "Readers can print this file",
	"FileUploadPlugin_Settings_ShowDownloadPDF_Label": "Readers can download this file",
	"FileUploadPlugin_Settings_FullPDFViewer_Label": "Full Viewer",
	"FileUploadPlugin_Settings_MiniPDFViewer_Label": "Mini Viewer",
	"FileUploadReplaceButton_tooltip": "Replace file",
	"TextColorButton_Tooltip": "Text color",
	"TextHighlightButton_Tooltip": "Highlight color",
	"Color_Picker_TextColorButton_Header": "Text Color",
	"Color_Picker_TextHighlightButton_Header": "Text Highlight Color",
	"Color_Picker_ThemeColor_Title": "Theme colors",
	"Color_Picker_CustomColor_Title": "Custom colors",
	"ColorPickerAddCustomColor_Tooltip": "Add custom color.",
	"Color_Picker_CustomColor_Panel_Title": "Custom",
	"ColorPickerButtonLabel_Cancel": "Cancel",
	"ColorPickerButtonLabel_Update": "Save",
	"ColorPickerLiveSiteColorHint": "Check your live site when adjusting colors. You’ll want to be sure text, buttons and other elements are easily visible.",
	"ColorPickerResetColor_Tooltip": "Reset to default color.",
	"LineSpacing_customSpacing": "Spacing options",
	"LineSpacing_customSpacing_Header": "Spacing",
	"LineSpacing_lineSpacing_Header": "Line Spacing",
	"LineSpacing_lineSpacing": "Line spacing",
	"LineSpacing_beforeParagraph": "Before paragraph (px)",
	"LineSpacing_afterParagraph": "After paragraph (px)",
	"LineSpacing_cancel": "Cancel",
	"LineSpacing_save": "Save",
	"LinkPanel_Learn_More_Label": "Learn more",
	"LinkPanel_AdvancedSettings_Label": "Advanced SEO settings",
	"LinkPanel_Noreferrer_Checkbox_Label": "noreferrer (recommended)",
	"LinkPanel_Nofollow_Checkbox_Label": "nofollow",
	"LinkPanel_Sponsored_Checkbox_Label": "sponsored",
	"LinkPanel_Noreferrer_Tooltip": "The linked website will not receive info on the referring site (your site).",
	"LinkPanel_Nofollow_Tooltip": "Let search engines know that you don't recommend giving credit to the linked page for SEO purposes.",
	"LinkPanel_Sponsored_Tooltip": "Let search engines know this link represents a paid ad, sponsorship or paid agreement.",
	"LinkPanel_Target_Checkbox": "Link opens in a new tab",
	"LinkPanel_Nofollow_Checkbox": "nofollow",
	"LinkPanel_Sponsored_Checkbox": "sponsored",
	"LinkPanel_Nofollow_Checkbox_Tooltip": "Let search engines know that you don't recommend giving credit to the linked page for SEO purposes.",
	"LinkPanel_InputPlaceholder": "Enter or paste a link",
	"LinkPanel_ErrorTooltip": "Enter a website URL, like www.example.com",
	"LinkPanelContainer_DoneButton": "Save",
	"LinkPanelContainer_CancelButton": "Cancel",
	"LinkPanelContainer_RemoveButton": "Remove Link",
	"LinkPanel_Anchor_Title": "Anchor",
	"LinkPanel_Anchor_Placeholder": "Select an anchor to link to",
	"LinkTo_Modal_Header": "What do you want to link to?",
	"Link_BasicModal_Header_Title": "Add a link",
	"Audio_Modal_Toggle_Source_Label": "Select a source",
	"Audio_Modal_Header_Title": "Add an audio file",
	"Video_Modal_Header_Title": "Add a video",
	"Giphy_Modal_Header_Title": "Add a GIF",
	"LinkTo_Modal_Sidebar_Website": "Web Address",
	"LinkTo_Modal_Sidebar_Section": "Section",
	"LinkTo_Modal_Website_Placeholder": "Paste the URL",
	"LinkTo_Modal_Section_Title": "Select a section to link to",
	"LinkTo_Modal_Section_EmptyState_Title": "Link to a Section",
	"LinkTo_Modal_Section_EmptyState_Text": "You'll be able to link to different parts of your post once you add more content.",
	"LinkTo_Modal_Section_Item_Gallery": "Gallery",
	"LinkTo_Modal_Section_Item_Heading": "Heading",
	"LinkTo_Modal_Section_Item_Paragraph": "Paragraph",
	"LinkTo_Modal_Section_Item_Image": "Image",
	"LinkTo_Modal_Section_Item_Codeblock": "Code block",
	"LinkTo_Modal_Section_Item_Video": "Video",
	"LinkTo_Modal_Section_Item_Quote": "Quote",
	"LinkTo_Modal_Section_Item_Map": "Map",
	"LinkTo_Modal_Section_Item_Button": "Button",
	"LinkTo_Modal_Section_Item_GIF": "GIF",
	"LinkTo_Modal_Section_Item_File": "File",
	"LinkTo_Modal_Section_Filter_All": "All",
	"LinkTo_Modal_Section_Filter_Headings": "Headings",
	"LinkTo_Modal_Section_Filter_Images": "Images",
	"LinkTo_Modal_Section_Filter_Galleries": "Galleries",
	"LinkTo_Modal_Section_Filter_Videos": "Videos",
	"LinkTo_Modal_Section_Filter_Paragraphs": "Paragraphs",
	"LinkTo_Modal_Section_Filter_Codeblocks": "Code blocks",
	"LinkTo_Modal_Section_Filter_Quotes": "Quotes",
	"LinkTo_Modal_Section_Filter_Maps": "Maps",
	"LinkTo_Modal_Section_Filter_Buttons": "Buttons",
	"LinkTo_Modal_Section_Filter_GIFs": "GIFs",
	"LinkTo_Modal_Section_Filter_Files": "Files",
	"LinkTo_Edit_Tooltip": "Edit link",
	"LinkTo_Toolbar_GoTo": "Go to link",
	"LinkPreview_RemovePreview_Tooltip": "Display as URL",
	"LinkPreview_Settings_Tooltip": "Link settings",
	"LinkSettings_MobileDrawer_Title": "Link",
	"LinkSettings_MobileDrawer_Edit": "Edit",
	"LinkSettings_MobileDrawer_Unlink": "Unlink",
	"LinkSettings_Modal_Title": "Link",
	"LinkSettings_Action_Unlink": "Unlink",
	"LinkSettings_Action_Cancel": "Cancel",
	"LinkSettings_Action_Save": "Save",
	"LinkSettings_Settings_NewTab_Label": "Links open in a new tab",
	"LinkSettings_Settings_Noreferrer_Label": "noreferrer",
	"LinkSettings_Settings_Noreferrer_Tooltip": "Hide info about link source.",
	"LinkSettings_Settings_Nofollow_Label": "nofollow",
	"LinkSettings_Settings_Nofollow_Tooltip": "Tell search engines to ignore link.",
	"LinkSettings_Settings_Sponsored_Label": "sponsored",
	"LinkSettings_Settings_Sponsored_Tooltip": "Mark link as sponsored.",
	"LinkSettings_NotPublishedWarning_Text": "Your site is not published. After publishing, it's a good idea to check and make sure all links work.",
	"LinkSettings_Sections_TypeDropdown_Label": "Filter sections by type",
	"LinkSettings_Sections_AutoComplete_Label": "Select a section to link to",
	"LinkSettings_Sections_MultiSelect_Label": "Select section(s) to link to",
	"LinkSettings_Sections_AutoComplete_NoResults_Search": "{{searchText}} not found",
	"LinkSettings_Sections_AutoComplete_NoResults_All": "No sections to link to",
	"LinkSettings_Sections_AutoComplete_Placeholder": "Select a section",
	"LinkSettings_Sections_MultiSelect_Placeholder": "Select section(s)",
	"LinkSettings_Sections_Empty_Text1": "No sections created yet",
	"LinkSettings_Sections_Empty_Text2": "Create sections or try another link type to link to.",
	"LinkSettings_SitePages_All_NoResults_Query": "{{query}} not found",
	"LinkSettings_SitePages_BlogPost_AutoComplete_Label": "Post",
	"LinkSettings_SitePages_BlogPost_AutoComplete_Placeholder": "Select a post",
	"LinkSettings_SitePages_BlogPost_NoResults_Any": "No blog posts to link to",
	"LinkSettings_SitePages_BlogPost_EmptyState_Text1": "No blog posts created yet",
	"LinkSettings_SitePages_BlogPost_EmptyState_Text2": "Create a blog post or try another link type to link to.",
	"LinkSettings_SitePages_StaticPage_AutoComplete_Label": "Page",
	"LinkSettings_SitePages_StaticPage_AutoComplete_Placeholder": "Select a page",
	"LinkSettings_SitePages_StaticPage_NoResults_Any": "No pages to link to",
	"LinkSettings_SitePages_StaticPage_EmptyState_Text1": "No pages created yet",
	"LinkSettings_SitePages_StaticPage_EmptyState_Text2": "Create a page or try another link type to link to.",
	"LinkSettings_TypeSelect_Label": "Link to",
	"LinkSettings_TypeSelect_Option_BlogPost": "Blog post",
	"LinkSettings_TypeSelect_Option_Section": "Section",
	"LinkSettings_TypeSelect_Option_StaticPage": "Page",
	"LinkSettings_TypeSelect_Option_WebAddress": "Web address",
	"LinkSettings_WebAddress_Label": "URL",
	"LinkSettings_WebAddress_InvalidLink": "Enter a valid link.",
	"LinkSettings_WebAddress_Placeholder": "Enter or paste a link",
	"LineSpacingButton_Tooltip": "Line spacing",
	"MobileLinkModal_Title": "Link",
	"Mobile_LinkPreview_Hide": "Hide",
	"SettingsPanelFooter_Save": "Save",
	"SettingsPanelFooter_Cancel": "Cancel",
	"DividerPlugin_InsertButton_Tooltip": "Add a divider",
	"DividerPlugin_SelectType_Tooltip": "Line style",
	"StoresPlugin_InsertButton_Tooltip": "Embed a product from Wix Stores",
	"EventsPlugin_InsertButton_Tooltip": "Embed an event from Wix Events",
	"BookingsPlugin_InsertButton_Tooltip": "Embed a service from Wix Bookings",
	"FacebookPlugin_InsertButton_Tooltip": "Add a Facebook post",
	"InstagramPlugin_InsertButton_Tooltip": "Add an Instagram post",
	"YouTubePlugin_InsertButton_Tooltip": "Add a YouTube video",
	"TwitterPlugin_InsertButton_Tooltip": "Add an X (Twitter) post",
	"TikTokPlugin_InsertButton_Tooltip": "Add a TikTok video",
	"PinterestPlugin_InsertButton_Tooltip": "Add a Pinterest pin",
	"AdSensePlugin_InsertButton_Tooltip": "Insert an ad",
	"CollapsibleListPlugin_InsertButton_Tooltip": "Add an expandable list",
	"HtmlPlugin_Edit_Modal_Title": "Edit HTML",
	"HtmlPlugin_InsertButton_Tooltip": "Insert HTML code",
	"HtmlPlugin_EditEmpty_Tooltip": "Add HTML or URL",
	"HtmlPlugin_EditHtml_Tooltip": "Edit HTML",
	"HtmlPlugin_EditUrl_Tooltip": "Change URL",
	"HtmlEditPanel_Code": "HTML",
	"HtmlEditPanel_Source": "Link",
	"HtmlEditPanel_Update": "Save",
	"HtmlEditPanel_Cancel": "Cancel",
	"HtmlEditPanel_HttpsError": "Make sure the URL starts with HTTPS",
	"HtmlEditPanel_UrlError": "Enter a website URL, like www.example.com",
	"HtmlEditPanel_HtmlInput_Placeholder": "Paste your code (HTTPS only)",
	"HtmlEditPanel_HtmlInput_AdSense_Title": "Insert an ad from AdSense",
	"HtmlEditPanel_HtmlInput_AdSense_Tooltip": "Copy the AdSense code from the Ads page in your Google AdSense account.",
	"HtmlEditPanel_HtmlInput_AdSense_Placeholder": "Paste your ad code",
	"HtmlEditPanel_UrlInput_Placeholder": "HTTPS only",
	"HtmlEditPanel_HtmlInput_DefaultText": "<p> Hello World! </p>",
	"HTMLPlugin_SliderModal_Title_Width": "Width",
	"HTMLPlugin_SliderModal_Title_Height": "Height",
	"HTMLPlugin_SliderModal_Toggle_AutoHeight": "Auto height",
	"ImagePlugin_Image_Preview_Alt": "Image preview",
	"ImagePlugin_Settings_Tab_Settings": "Settings",
	"ImagePlugin_Settings_Tab_Design": "Design",
	"ImagePlugin_InsertButton_Tooltip": "Add an image",
	"ImagePlugin_Design_Corners": "Corners",
	"ImagePlugin_Design_Corner_Radius": "Corner radius",
	"ImagePlugin_Design_Border": "Border",
	"ImagePlugin_Design_Border_Color": "Border color",
	"ImagePlugin_Design_Border_Width": "Border width",
	"ImagePlugin_Settings_Section_Options": "Options",
	"ImagePlugin_Settings_Is_Decorative": "Is decorative?",
	"ImagePlugin_Settings_Is_Decorative_Tooltip": "Marks this image as decorative, meaning it won’t be announced by screen readers. Use for purely visual elements—alt text is not required.",
	"ImagePlugin_Settings_ImageOpensInExpandMode_Label": "Click to expand",
	"ImagePlugin_Settings_ImageCanBeDownloaded_Label": "Allow download",
	"ImagePlugin_Settings_ImageCanBeDownloaded_Tooltip": "Allows people to download this image by right-clicking on it and selecting Save Image As.",
	"ImageSettings_Update": "Save",
	"ImageSettings_Header": "Image",
	"ImageSettings_Caption_Label": "Caption",
	"ImageSettings_Caption_Input_Placeholder": "Add a caption here",
	"ImageSettings_Alt_Label": "Alt text",
	"ImageSettings_Alt_Input_Placeholder": "e.g., A cat sleeping on a white blanket",
	"ImageSettings_Link_Label": "Link",
	"ImageSettings_Link_RedirectToToolbar": "To update the image link, go to the image toolbar and open link settings.",
	"ImageEditorButton_Tooltip": "Edit image",
	"ImageSettings_Spoiler_Toggle": "Mark as spoiler",
	"ImageSettings_Expand_Mode_Toggle": "Clicking on the image will expand it.",
	"Spoiler_Toggle_Tooltip": "Blur the content so that people have to click on it to see it.",
	"Embed_Add_Button_Label": "Embed",
	"EmbedURL_Common_CTA_Primary": "Add",
	"EmbedURL_Common_CTA_Secondary": "Cancel",
	"EmbedURL_Social_Facebook_Header_Title": "Embed Facebook",
	"EmbedURL_Social_TikTok_Header_Title": "Embed TikTok",
	"EmbedURL_Social_YouTube_Header_Title": "Embed Youtube",
	"EmbedURL_Social_Pinterest_Header_Title": "Embed Pinterest",
	"EmbedURL_Social_Instagram_Header_Title": "Embed Instagram",
	"EmbedURL_Social_Twitter_Header_Title": "Embed X (Twitter)",
	"EmbedURL_Social_Facebook_Title": "Add a Facebook Post",
	"EmbedURL_Social_Facebook_Placeholder": "Paste the URL of a public post",
	"EmbedURL_Social_TikTok_Title": "Paste a link to a TikTok Video",
	"EmbedURL_Social_TikTok_Placeholder": "e.g., www.tiktok.com/example",
	"EmbedURL_Social_YouTube_Title": "Paste a link to a YouTube Video",
	"EmbedURL_Social_YouTube_Placeholder": "e.g., www.youtube.com/example",
	"EmbedURL_Social_Pinterest_Title": "Add a Pinterest Pin",
	"EmbedURL_Social_Pinterest_Placeholder": "Paste the URL of a board or pin",
	"EmbedURL_Social_Instagram_Title": "Paste a link to an Instagram post",
	"EmbedURL_Social_Instagram_Placeholder": "e.g., www.instagram.com/example",
	"EmbedURL_Social_Twitter_Title": "Paste a link to an X (Twitter) post",
	"EmbedURL_Social_Twitter_Placeholder": "e.g., www.twitter.com/example",
	"EmbedURL_Placeholder": "e.g. www.youtube.com/example",
	"EmbedURL_MobileHeader": "Embed",
	"VideoModal_MobileHeader": "Video",
	"VideoCustomUploadModal_Title": "Upload a video from your computer or device",
	"VideoModal_Tabs_Embed": "Embed",
	"VideoModal_Tabs_Upload": "Upload",
	"VideoModal_Embed_Title": "Paste a URL from YouTube, Vimeo or Facebook",
	"VideoModal_Embed_ButtonText": "Embed Video",
	"VideoUploadModal_Title": "Add a Video",
	"VideoUploadModal_AddButtonText": "Add",
	"VideoUploadModal_CustomVideoHeader": "Or upload a video from your computer/device",
	"VideoUploadModal_CustomVideoClickText": "Upload Video",
	"VideoPlugin_InsertButton_Tooltip": "Add a video",
	"VideoPlugin_Settings_VideoCanBeDownloaded_Label": "Allow download",
	"VideoPlugin_Settings_VideoCanBeDownloaded_Tooltip": "Allow viewers to download your video.",
	"VideoPlugin_Settings_Header": "Video Settings",
	"VideoUploadModal_Header": "Paste a URL from YouTube, Vimeo or Facebook",
	"VideoUploadModal_Input_Placeholder": "e.g., https://youtu.be/6sx-xGiFIjk",
	"VideoUploadModal_Input_InvalidUrl": "Check the URL and try again",
	"VideoComponent_Overlay": "To play this video, view this post from your live site.",
	"VideoSettings_Spoiler_Toggle": "Mark as spoiler",
	"VideoSettings_Autoplay_Tooltip": "The video starts on mute automatically when people first see it. Viewers have the option to unmute it.",
	"VideoSettings_Embed_Videos_Alert": "Some settings may not be applied depending on the video source. All settings should work properly for Youtube and Vimeo videos.",
	"Settings_Replace_Image_Tooltip": "Replace",
	"Settings_Remove_Image_Tooltip": "Remove",
	"MediaModal_Tabs_Embed": "Embed",
	"MediaModal_Tabs_Upload": "Upload",
	"Media_Autoplay_Label": "Autoplay",
	"Media_Play_In_Loop_Label": "Play in a loop",
	"Media_Playback_Options_Label": "Playback options",
	"Media_Controls_Label": "Controls",
	"Media_Controls_Subtitle": "When playing, controls show:",
	"Media_Controls_Show_On_Hover": "On hover",
	"Media_Controls_Show_Never": "Never",
	"AudioPlugin_Download_Label": "Download",
	"AudioPlugin_PlaybackSpeed_Label": "Playback Speed",
	"AudioPlugin_Toolbar_Edit_Label": "Edit",
	"AudioModal_Embed_ButtonText": "Embed Audio",
	"AudioModal_Upload_ButtonText": "Upload File",
	"AudioModal_Embed_Title": "Paste a URL from SoundCloud or Spotify",
	"AudioModal_Upload_Title": "Upload an audio file from your computer",
	"AudioModal_Mobile_Upload_Title": "Upload an audio file from your device",
	"AudioPlugin_InsertButton": "Audio",
	"AudioPlugin_InsertButton_Tooltip": "Add an audio file",
	"AudioPlugin_Settings_Header": "Audio",
	"AudioPlugin_Settings_AudioCanBeDownloaded_Label": "Allow download",
	"AudioPlugin_Settings_AudioCanBeDownloaded_Tooltip": "Allows people to download this audio file.",
	"AudioPlugin_Settings_CoverImage_Label": "Cover image",
	"AudioPlugin_Settings_AuthorName_Label": "Creator",
	"AudioPlugin_Settings_AudioName_Label": "Title",
	"AudioPlugin_Settings_AudioName_Label_Placeholder": "Add a title",
	"AudioPlugin_Settings_AuthorName_Label_Placeholder": "Add the creator’s name ",
	"Spotify_InsertButton": "Spotify",
	"Spotify_InsertButton_Tooltip": "Add a Spotify track",
	"SoundCloudPlugin_InsertButton_Tooltip": "Add a SoundCloud track",
	"SoundCloudUploadModal_Header": "Add a SoundCloud track",
	"SoundCloudUploadModal_Header_Mobile": "Add a track from SoundCloud",
	"SoundCloudUploadModal_Input_Placeholder": "e.g., https://soundcloud.com/example",
	"SoundCloudUploadModal_Input_InvalidUrl": "Check the URL and try again",
	"SoundCloudComponent_Overlay": "To play this track, view this post from your live site.",
	"GiphyPlugin_InsertButton_Tooltip": "Add a GIF",
	"GiphyPlugin_InsertModal_Header_Title": "GIFs & Stickers",
	"GiphyPlugin_InsertModal_Gifs": "GIFs",
	"GiphyPlugin_InsertModal_Stickers": "Stickers",
	"GiphyPlugin_Trending": "Trending",
	"GiphyPlugin_ApiErrorMsg": "Can't access GIPHY due to a technical issue. Refresh the page and try again.",
	"GiphyPlugin_ApiErrorMsg_Title": "Can't access GIPHY due to a technical issue.",
	"GiphyPlugin_ApiErrorMsg_Subtitle": "Refresh the page and try again.",
	"GiphyPlugin_Search_EmptyState_Title": "No GIFs found.",
	"GiphyPlugin_Search_EmptyState_Title_Stickers": "No Stickers found.",
	"GiphyPlugin_Search_EmptyState_Text": "Try another search term.",
	"GiphyUploadModal_Input_Placeholder": "Search",
	"GiphyUploadModal_Search_Placeholder": "Search for a GIF",
	"GiphyUploadModal_Search_Placeholder_Stickers": "Search for a Sticker",
	"GiphyUploadModal_mobileNavbar_Title": "Choose a GIF",
	"MapSettings_Title": "Map",
	"MapSettings_Location_Input_Label": "Location",
	"MapSettings_Location_Input_Placeholder": "Address",
	"MapSettings_Location_Display_Name": "Location Display Name",
	"MapSettings_Location_Display_Name_Placeholder": "Give this location a name",
	"MapSettings_MapOption_SubHeader": "Map Behavior",
	"MapSettings_MapOption_Show_Marker_Label": "Show marker",
	"MapSettings_MapOption_Show_Zoom_Label": "Show zoom",
	"MapSettings_MapOption_Show_Street_View_Label": "Show street view",
	"MapSettings_MapOption_Show_View_Control_Label": "Show map and satellite views",
	"MapSettings_MapOption_Allow_Dragging_Label": "Allow dragging",
	"MapPlugin_InsertButton_Tooltip": "Add a map",
	"MapPluginButton_Settings_Tooltip": "Map settings",
	"MapSettings_Location_Suggestion_Input_No_Results_Found": "No results found",
	"GalleryPlugin_InsertButton_Tooltip": "Add a gallery",
	"GalleryPlugin_Image_Preview_Alt": "Image preview",
	"GalleryPlugin_Item_Thumbnail_Alt": "Gallery item thumbnail",
	"GalleryPlugin_Layout_Grid": "Grid",
	"GalleryPlugin_Layout_Masonry": "Masonry",
	"GalleryPlugin_Layout_Collage": "Collage",
	"GalleryPlugin_Layout_Thumbnails": "Thumbnails",
	"GalleryPlugin_Layout_Slideshow": "Slideshow",
	"GalleryPlugin_Layout_Panorama": "Panorama",
	"GalleryPlugin_Layout_Columns": "Columns",
	"GalleryPlugin_Layout_Slides": "Slider",
	"GalleryPlugin_Layouts_Title": "Choose a gallery layout",
	"GalleryPlugin_Layouts_Customize_Button": "Customize Layout",
	"GalleryPlugin_Layout_Options_Title": "Properties",
	"GalleryPlugin_Settings_ImagesOpenInExpandMode_Label": "Click to expand",
	"GalleryPlugin_Settings_ImagesCanBeDownloaded_Tooltip": "Allows people to download images from this gallery by right-clicking on them and selecting Save Image As.",
	"GalleryPlugin_Settings_ImagesCanBeDownloaded_Label": "Allow download",
	"GalleryPlugin_Settings_Tab_ManageMedia": "Media",
	"GallerySettings_Header": "Gallery",
	"GallerySettings_Image_Settings_Header": "Image",
	"GallerySettings_Tab_ManageMedia": "Media",
	"GallerySettings_Tab_Settings": "Settings",
	"GallerySettings_Toolbar_Button_MangeMedia": "Manage Media",
	"GallerySettings_Tab_AdvancedSettings": "Layout",
	"GallerySettings_LayoutControlSection_Column": "Column width",
	"GallerySettings_LayoutControlSection_Row": "Row height",
	"GallerySettings_Add_Media": "Add Media",
	"GallerySettings_Finish_Sorting": "Save",
	"GallerySettings_Sort_Items": "Reorder Media",
	"GallerySettings_Select_All": "Select All",
	"GallerySettings_Deselect": "Unselect All",
	"GallerySettings_Delete": "Delete",
	"GallerySettings_Image_Settings": "Edit",
	"GallerySettings_Upload_Media": "Upload Media",
	"GalleryImageSettings_Update": "Save",
	"GalleryImageSettings_Header": "Edit Image",
	"GalleryImageSettings_Replace_Label": "Replace",
	"GalleryImageSettings_Delete_Label": "Delete",
	"GalleryImageSettings_Title_Label": "Caption",
	"GalleryImageSettings_Title_Input_Placeholder": "Write a catchy title",
	"GalleryImageSettings_Link_Label": "Link",
	"GalleryImageSettings_Add_Link_Button": "Choose a link",
	"GallerySettings_Sliders_Items_Per_Row": "Images per row",
	"GallerySettings_Spacing_Between_Items": "Spacing (px)",
	"GallerySettings_Radios_Thumbnail_Resize": "Thumbnail resize",
	"GallerySettings_Radios_Crop": "Crop",
	"GallerySettings_Radios_Fit": "Fit",
	"GallerySettings_Radios_Title_Button_Placement": "Title placement",
	"GallerySettings_Radios_Underneath": "Under image",
	"GallerySettings_Radios_On_Hover": "On hover",
	"GallerySettings_Radios_Image_Orientation": "Image orientation",
	"GallerySettings_Radios_Vertical": "Vertical",
	"GallerySettings_Radios_Horizontal": "Horizontal",
	"GallerySettings_Radios_Scroll_Direction": "Scroll direction",
	"GallerySettings_Image_Ratio": "Image ratio",
	"GallerySettings_Thumbnail_Placement": "Thumbnail placement",
	"GallerySettings_Spoiler_Toggle": "Mark as spoiler",
	"GallerySettings_Expand_Mode_Toggle": "Clicking on images will expand them.",
	"ButtonPlugin_InsertButton_Tooltip": "Add a button",
	"ButtonModal_InputName_Placeholder": "e.g., Click here",
	"ButtonModal_InputLink_ErrorMessage": "e.g., www.example.com",
	"ButtonModal_Header": "Button",
	"ButtonModal_New_Tap": "Link opens in a new tab",
	"ButtonModal_Nofollow_Tags": "Tell Google to ignore this link (nofollow)",
	"ButtonModal_Button_Text": "Button text",
	"ButtonModal_Button_Link": "Link",
	"ButtonModal_Settings_Tab": "Settings",
	"ButtonModal_Design_Tab": "Design",
	"ButtonModal_Size_Section": "Size",
	"ButtonModal_Border_Section": "Border",
	"ButtonModal_Text_Section": "Text",
	"ButtonModal_Width_Input": "Border width",
	"ButtonModal_Radius_Input": "Corner radius",
	"ButtonModal_Text_Color": "Text color",
	"ButtonModal_Border_Color": "Border color",
	"ButtonModal_Button_Sample_text": "Click Me",
	"ButtonModal_Background_Color": "Background color",
	"ButtonModal_Invalid_Link": "Invalid link",
	"ButtonModal_Link_Input_Placeholder": "Enter a URL",
	"ButtonModal_Color_Input_Label": "Hex",
	"ButtonModal_Preview_Label": "Preview",
	"ButtonColourModal_Title": "Colours",
	"ButtonComponent_Error_Overlay": "Enter a valid URL for the button",
	"ButtonPlugin_Navbar_Cancel_button": "Cancel",
	"ButtonPlugin_Navbar_Update_button": "Save",
	"TextAlignmentButton_Tooltip": "Alignment",
	"TextLinkButton_Tooltip": "Link{{shortcut}}",
	"TextLinkButton_DisableButtonForPlugins_Tooltip": "Inline links can not be applied to plugins",
	"FormattingToolbar_TextStyle_Heading": "Heading {{number}}{{shortcut}}",
	"FormattingToolbar_TextStyle_Heading_Apply": "Apply ’{{optionName}}’",
	"FormattingToolbar_TextStyle_Heading_Update": "Match all ’{{optionName}}’",
	"FormattingToolbar_TextStyle_Heading_Reset": "Reset to default",
	"FormattingToolbar_TextStyle_Paragraph": "Paragraph{{shortcut}}",
	"FormattingToolbar_CustomFontSizeButton_Tooltip": "Font Size",
	"FormattingToolbar_TextStyle_Update_Heading_Tooltip": "Updates all '{{optionName}}' in this post to match your new formatting.",
	"FormattingToolbar_LineSpacingPanelHeader": "Line Spacing",
	"FormattingToolbar_AlignmentPanelHeader": "Alignment",
	"FormattingToolbar_HeadingsPanelHeader": "Headings",
	"MoreButton_Tooltip": "More",
	"BoldButton_Tooltip": "Bold{{shortcut}}",
	"ItalicButton_Tooltip": "Italic{{shortcut}}",
	"UnderlineButton_Tooltip": "Underline{{shortcut}}",
	"IndentButton_Tooltip": "Indent",
	"TitleButton_Tooltip": "Title",
	"FormattingToolbar_TextStyleButton_Tooltip": "Text style",
	"QuoteButton_Tooltip": "Quote{{shortcut}}",
	"AlignTextDropdownButton_Tooltip": "Alignment",
	"AlignTextLeftButton_Tooltip": "Align left{{shortcut}}",
	"AlignTextCenterButton_Tooltip": "Align center{{shortcut}}",
	"AlignTextRightButton_Tooltip": "Align right{{shortcut}}",
	"AlignTextJustifyButton_Tooltip": "Justify{{shortcut}}",
	"AlignObject_Left_Tooltip": "Align left",
	"AlignObject_Center_Tooltip": "Align center",
	"AlignObject_Right_Tooltip": "Align right",
	"TextwrapObject_ToggleButton": "Wrap text",
	"TextwrapObject_ToggleButton_Info_UnsupportedContainer": "Text wrapping not available in lists and layouts.",
	"TextwrapObject_ToggleButton_Info_AlignedCenter": "Text wrapping not available for center aligned elements.",
	"ChangeDimensions_Width_Tooltip": "Width",
	"ChangeDimensions_Height_Tooltip": "Height",
	"DividerPlugin_Width_Small_Tooltip": "Small",
	"DividerPlugin_Width_Medium_Tooltip": "Medium",
	"DividerPlugin_Width_Large_Tooltip": "Full width",
	"GalleryPlugin_Layout_Select_Tooltip": "Gallery layout",
	"Spoiler_Insert_Tooltip": "Spoiler",
	"AnchorPlugin_Settings_Tooltip": "Edit anchor name",
	"AnchorPlugin_AddAnchor_Tooltip": "Add an anchor",
	"AnchorPlugin_MoveUp_Tooltip": "Move up",
	"AnchorPlugin_MoveDown_Tooltip": "Move down",
	"AnchorPlugin_Modal_Placeholder": "Anchor {{number}}",
	"AnchorPlugin_Modal_Description": "Anchors are invisible on the live site, but you can create links to them. When people click the link, they’ll reach the anchor’s location.",
	"OrderedListButton_Tooltip": "Numbered list{{shortcut}}",
	"UnorderedListButton_Tooltip": "Bulleted list{{shortcut}}",
	"SizeSmallButton_Tooltip": "Small",
	"SizeMediumButton_Tooltip": "Medium",
	"SizeLargeButton_Tooltip": "Large",
	"WidthButton_Tooltip": "Width",
	"HeightButton_Tooltip": "Height",
	"SizeOriginalButton_Tooltip": "Original size",
	"SizeSmallCenterButton_Tooltip": "Compact",
	"SizeSmallLeftButton_Tooltip": "Align left",
	"AlignCenterButton_Tooltip": "Align center",
	"SizeSmallRightButton_Tooltip": "Align right",
	"SizeContentButton_Tooltip": "Standard",
	"SizeFullWidthButton_Tooltip": "Extended",
	"DeleteButton_Tooltip": "Delete",
	"EditButton_Tooltip": "Edit",
	"SettingsButton_Tooltip": "Settings",
	"UploadMediaButton_Tooltip": "Upload media",
	"ManageMediaButton_Tooltip": "Organize media",
	"ReplaceVideoButton_Tooltip": "Replace video",
	"ReplaceSoundCloudButton_Tooltip": "Replace SoundCloud track",
	"ReplaceGiphyButton_Tooltip": "Replace GIF",
	"ReplaceImageButton_Tooltip": "Replace image",
	"EmojiPlugin_InsertModal_Title": "Emoji",
	"EmojiPlugin_InsertButton_Tooltip": "Add an emoji",
	"EmojiPlugin_EmojiGroups_People": "People",
	"EmojiPlugin_EmojiGroups_Nature": "Nature",
	"EmojiPlugin_EmojiGroups_Food": "Food & Drink",
	"EmojiPlugin_EmojiGroups_Activity": "Activity",
	"EmojiPlugin_EmojiGroups_Travel": "Travel & Places",
	"EmojiPlugin_EmojiGroups_Objects": "Objects",
	"EmojiPlugin_EmojiGroups_Symbols": "Symbols",
	"EmojiPlugin_EmojiGroups_Flags": "Flags",
	"EmojiPlugin_PoweredBy_label": "POWERED BY ",
	"TitleButton_label": "Title",
	"TitleButton_tooltip": "Title",
	"HeadingOneButton_label": "Heading 1",
	"HeadingTwoButton_label": "Heading 2",
	"HeadingThreeButton_label": "Heading 3",
	"HeadingOneButton_tooltip": "Heading 1",
	"HeadingTwoButton_tooltip": "Heading 2",
	"HeadingThreeButton_tooltip": "Heading 3",
	"TextCodeBlockButton_Tooltip": "Code snippet{{shortcut}}",
	"decreaseIndentButton_Tooltip": "Decrease indent{{shortcut}}",
	"increaseIndentButton_Tooltip": "Increase indent{{shortcut}}",
	"TextCodeBlock_InsertButton_Tooltip": "Add a code snippet",
	"UndoButton_Tooltip": "Undo",
	"RedoButton_Tooltip": "Redo",
	"ColorPicker_SetToDefault_ButtonLabel": "Reset to Default",
	"ColorPicker_RemoveColor_Tooltip": "Transparent",
	"CustomColorPicker_Empty_Placeholder": "Enter a color",
	"ImageSettings_Alt_Label_Tooltip": "Search engines can’t see images, but they can read Alt text. Describe what's in every image to push your pages higher up on search results.",
	"GallerySettings_Radios_Thumbnail_Resize_Tooltip": "Choose Crop to select what your visitors see, or choose Fit to use the whole photo as the thumbnail.",
	"GallerySettings_Radios_Scroll_Direction_Tooltip": "Vertical lets visitors scroll up and down to view images. While horizontal lets visitors scroll left and right.",
	"GallerySettings_Radios_Image_Orientation_Tooltip": "Use Vertical for portraits and tight shots, and Horizontal for wide angle and landscape shots.",
	"GallerySettings_Spacing_Between_Items_Tooltip": "Set the spacing between the items in your gallery.",
	"Common_Units_PX": "px",
	"Shortcut_Toolbar_ViewAll_Blocks": "More",
	"BlockToolbar_Section_NoSections_ShortcutToolbar": "More Blocks",
	"BlockToolbar_Section_NoSections": "Add a Block",
	"BlockToolbar_Search_Placeholder": "Search for a block",
	"BlockToolbar_Search_EmptyState": "No blocks found.\nTry another search term.",
	"BlockToolbar_Section_Basic": "Basic",
	"BlockToolbar_Section_Embed_Social": "Embed from Social",
	"BlockToolbar_Section_Embed_Wix": "Embed from Wix",
	"BlockToolbar_Section_Embed_Anywhere": "Embed from Anywhere",
	"BlockToolbar_Section_Advanced": "Advanced ",
	"AdSensePlugin_InsertButton": "Wix Monetize with AdSense",
	"EmbedCustomPlugin_InsertButton": "Custom",
	"BlockToolbar_Section_Tools": "Tools",
	"DividerPlugin_InsertButton": "Divider",
	"ImagePlugin_InsertButton": "Image",
	"GalleryPlugin_InsertButton": "Gallery",
	"VideoPlugin_InsertButton": "Video",
	"CodeblockPlugin_InsertButton": "Code Block",
	"SoundcloudPlugin_InsertButton": "SoundCloud",
	"GIFPlugin_Mobile_Header": "GIF",
	"GIFPlugin_InsertButton": "GIF",
	"MapPlugin_InsertButton": "Map",
	"UploadFilePlugin_InsertButton": "File",
	"ButtonPlugin_InsertButton": "Button",
	"UndoPlugin_InsertButton": "Undo",
	"RedoPlugin_InsertButton": "Redo",
	"PollPlugin_InsertButton": "Poll",
	"EmojiPlugin_InsertButton": "Emoji",
	"HTMLCodePlugin_InsertButton": "HTML code",
	"Facebook_InsertButton": "Facebook",
	"Instagram_InsertButton": "Instagram",
	"TikTok_InsertButton": "TikTok",
	"Pinterest_InsertButton": "Pinterest",
	"Twitter_InsertButton": "X (Twitter)",
	"YouTube_InsertButton": "YouTube",
	"CollapsibleList_InsertButton": "Expandable List",
	"Stores_InsertButton": "Stores",
	"Bookings_InsertButton": "Bookings",
	"Events_InsertButton": "Events",
	"Layout_InsertButton": "Columns",
	"UploadFile_Download_CTA": "Download {{filetype}}",
	"Poll_InsertPoll_Tooltip": "Create a poll",
	"Poll_FormatToolbar_Preview_Tooltip": "Preview",
	"Poll_FormatToolbar_Settings_Tooltip": "Manage poll settings",
	"Poll_FormatToolbar_Layout_Tooltip": "Change poll layout",
	"Poll_FormatToolbar_Design_Tooltip": "Customize poll design",
	"Poll_Editor_Question_Placeholder": "Ask your question",
	"Poll_Editor_Answer_Placeholder": "Write an answer",
	"Poll_Editor_Answer_AddAnswer": "Add answer",
	"Poll_Editor_Answer_Error_NoEdit_Tooltip": "You can't edit answers that have votes.",
	"Poll_Mobile_Editor_Toolbar_Edit": "Edit text",
	"Poll_Mobile_Editor_Toolbar_Customize": "Customize",
	"Poll_Preview_Close_CTA": "Close Preview",
	"Poll_Presets_Popup_Title": "Choose a Poll Type",
	"Poll_Presets_Popup_Subtitle": "You can customize the look and feel later.",
	"Poll_Presets_Popup_Option_TextList": "Simple",
	"Poll_Presets_Popup_Option_TextListAndMainImage": "With Image",
	"Poll_Presets_Popup_Option_ImagesGrid": "Grid",
	"Poll_Presets_Popup_CTA": "Select",
	"Poll_PollSettings_Common_Header": "Poll",
	"Poll_PollSettings_Tab_Layout_TabName": "Layout",
	"Poll_PollSettings_Tab_Design_TabName": "Design",
	"Poll_PollSettings_Tab_Settings_TabName": "Settings",
	"Poll_PollSettings_Tab_Layout_Section_Question_Header": "Questions",
	"Poll_PollSettings_Tab_Layout_Section_Question_Image": "Add an image to the question",
	"Poll_PollSettings_Tab_Layout_Section_Answers_Header": "Answers",
	"Poll_PollSettings_Tab_Layout_Section_Answers_Layout": "Choose a layout",
	"Poll_PollSettings_Tab_Layout_Section_Answers_Layout_List": "List",
	"Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid": "Grid",
	"Poll_PollSettings_Tab_Layout_Section_Answers_Image": "Add an image to each answer",
	"Poll_PollSettings_Tab_Layout_Section_TextDirection_Header": "Poll Direction",
	"Poll_PollSettings_Tab_Layout_Section_TextDirection_Choose": "Choose a poll direction",
	"Poll_PollSettings_Tab_Layout_Section_TextDirection_Header_Tooltip": "For websites in languages that read from right to left, show the poll from right to left.",
	"Poll_PollSettings_Tab_Layout_Section_TextDirection_LTR": "From Left",
	"Poll_PollSettings_Tab_Layout_Section_TextDirection_RTL": "From Right",
	"Poll_PollSettings_Tab_Design_Section_Background_Header": "Background",
	"Poll_PollSettings_Tab_Design_Section_Background_Choose": "Choose a style",
	"Poll_PollSettings_Tab_Design_Section_Background_Pattern": "Image",
	"Poll_PollSettings_Tab_Design_Section_Background_Pattern_Pick": "Pick an image",
	"Poll_PollSettings_Tab_Design_Section_Background_Gradient": "Gradient",
	"Poll_PollSettings_Tab_Design_Section_Background_Gradient_Pick": "Pick a gradient",
	"Poll_PollSettings_Tab_Design_Section_Background_Color": "Color",
	"Poll_PollSettings_Tab_Design_Section_Background_Color_Pick": "Pick a color",
	"Poll_PollSettings_Tab_Design_Section_CornerRadius_Header": "Corner Roundness",
	"Poll_PollSettings_Tab_Design_Section_CornerRadius_Poll": "Poll (px)",
	"Poll_PollSettings_Tab_Design_Section_CornerRadius_Answers": "Answers (px)",
	"Poll_PollSettings_Tab_Settings_Section_Voting_Header": "Voting",
	"Poll_PollSettings_Tab_Settings_Section_Voting_Permission_Title": "Who can vote?",
	"Poll_PollSettings_Tab_Settings_Section_Voting_Permission_SiteMember": "Site members",
	"Poll_PollSettings_Tab_Settings_Section_Voting_Permission_All": "Everyone",
	"Poll_PollSettings_Tab_Settings_Section_Voting_Multiselect": "Allow multiple answers",
	"Poll_PollSettings_Tab_Settings_Section_Results_Header": "Results",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_Title": "Who can see the results?",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_Owner": "Only me",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_Owner_Tooltip": "You can see the poll results while others can only see what they voted for.",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_Voters": "Voters",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_Voters_Tooltip": "Only you and people who vote can see the results.",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_All": "Everyone",
	"Poll_PollSettings_Tab_Settings_Section_Results_Permission_All_Tooltip": "Everyone can see the poll results at any time.",
	"Poll_PollSettings_Tab_Settings_Section_Results_VoteVisibility": "Show vote count",
	"Poll_PollSettings_Tab_Settings_Section_Results_VoterAnonymous": "Show what each and every person voted for",
	"Image_plugin_search_tags": "image photo picture file camera visual scan upload",
	"Image_Caption_Input_Placeholder": "Write a caption for your image",
	"Figure_Caption_Input_Placeholder": "Write a caption",
	"Video_Caption_Input_Placeholder": "Write a description",
	"Gallery_plugin_search_tags": "gallery image collage photo picture pixel camera visual slideshow layout exhibit showcase",
	"Video_plugin_search_tags": "video movie clip music audio mtv youtube camera song visual digital film upload animated tape recording viral",
	"Audio_plugin_search_tags": "audio movie clip music mtv youtube camera song visual digital film upload animated tape recording viral",
	"HTML_plugin_search_tags": "html code program develop lib web format embed online article content inject",
	"Divider_plugin_search_tags": "divider separator paragraph split phase draw line section",
	"codeBlock_plugin_search_tags": "code block program embed develop automate codify format snippet quote robot font",
	"SoundCloud_plugin_search_tags": "sound cloud song music echo sonic stereo audio volume listen track",
	"Map_plugin_search_tags": "map road place location access graph photo vector explore geography atlas city country area neighborhood region",
	"UploadFile_plugin_search_tags": "upload file storage auto post format store download share viral content media digital picture video image pdf document folder zip",
	"Button_plugin_search_tags": "button click press switch action toggle",
	"Undo_plugin_search_tags": "undo revert delete paste back change",
	"Redo_plugin_search_tags": "redo revert update change back",
	"Emoji_plugin_search_tags": "emoji emoticon gif reaction smiley icon like face picture symbol",
	"Gif_plugin_search_tags": "gif giphy video movie clip music audio mtv youtube camera song visual digital film upload animated viral image",
	"Facebook_plugin_search_tags": "facebook post social media embed",
	"Instagram_plugin_search_tags": "instagram post photo video social media embed",
	"Pinterest_plugin_search_tags": "pinterest post board social media embed",
	"Twitter_plugin_search_tags": "twitter tweet post social media embed",
	"YouTube_plugin_search_tags": "youtube video music social media embed",
	"TikTok_plugin_search_tags": "tiktok video social media embed",
	"Events_plugin_search_tags": "event ticket social media embed wix",
	"Bookings_plugin_search_tags": "booking event social media embed wix",
	"Stores_plugin_search_tags": "stores product social media embed wix",
	"Adsense_plugin_search_tags": "advertisement adsense google promotion embed commercial html code",
	"CollapsibleList_ShownText_Placeholder": "Write a title",
	"CollapsibleList_CollapsedText_Placeholder": "Add content to expand",
	"CollapsibleList_ShownText_Add_Placeholder": "Add another expandable item",
	"CollapsibleList_CollapsibleListSettings_Common_Header": "Expandable List",
	"CollapsibleList_CollapsibleListSettings_Section_Display_Title": "Display",
	"CollapsibleList_CollapsibleListSettings_Section_Settings_Title": "Settings",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_TabName": "Design",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_TabName": "Settings",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Icon_Title": "Choose an icon",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Icon_Color": "Icon color",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Border_Title": "Border",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Border_OpacityColor": "Opacity & color",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Background_Title": "Background",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_Background_OpacityColor": "Opacity & color",
	"CollapsibleList_CollapsibleListSettings_Tab_Design_ExpandedText_OpacityColor": "Opacity & color",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Title": "How many items are expanded by default?",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Expanded": "All",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Collapsed": "None",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_FirstExpanded": "First item only",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_InSections": "Expand one item at a time",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title": "Choose a direction",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title_Tooltip": "For websites in languages that read from right to left, show the list from right to left.",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_LTR": "Left",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_RTL": "Right",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Toggle": "Enable FAQ markup",
	"CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Tooltip": "FAQ structured data markup allows search engines to identify your list as an FAQ section and can improve your site’s visibility.",
	"UploadFile_Error_Generic_Item": "File was not uploaded",
	"UploadFile_Error_Generic_Toast": "File was not uploaded. Try again.",
	"UploadFile_Error_Generic_Toast_Multiple": "{{errors}} files were not uploaded. Try again.",
	"UploadFile_Error_Size_Toast": "Max file size is {{maxLimit}}MB. Try a smaller file.",
	"UploadFile_Error_Size_Item": "This file is too big",
	"UploadFile_Error_StorageExceeded_Visitor": "Files can't be uploaded right now. Contact the site owner for more information.",
	"UploadFile_Error_StorageExceeded_SiteOwner": "You've exceeded your site's storage limit. To save more media on your site, <1>upgrade now</1>.",
	"UploadFile_Error_Mimetype_Mismatch": "This file's extension and file type don't match so it can’t be uploaded. Rename the extension and try again.",
	"UploadFile_Error_WMP_General": "The file could not be uploaded. Check your internet connection and try again.",
	"UploadFile_Error_General_Logged_Out": "You’re signed out. Sign in to try again.",
	"UploadFile_Error_Corrupt_File": "This file is corrupted so it can’t be uploaded. Try a different file.",
	"UploadFile_Error_Unsupported_Extension": "{{extension}} files are not supported. Try a different file.",
	"UploadFile_Error_External_File_Authorizaion": "An unexpected error has occurred. Refresh your browser and upload your file again.",
	"UploadFile_Error_Empty_File": "This file is empty. Try a different file.",
	"UploadImage_Error_Unsupported_Image_Format": "This image file is not in a supported format and can’t be uploaded. Try a different file.",
	"UploadImage_Error_Corrupted_Image": "This image is corrupted so it can’t be uploaded. Try a different file.",
	"UploadImage_Error_Image_Dimensions_Exceeded": "This image is too big and can't be uploaded. Upload a smaller image (10,000 x 10,000px max).",
	"UploadAudio_Error_Unsupported_Stereo_Format": "This audio file is not in a supported stereo format and can’t be uploaded. Try a different file.",
	"UploadAudio_Error_Unsupported_Bit_Rate": "This audio file is not in a supported bit rate and can’t be uploaded. Try a different file.",
	"UploadAudio_Error_MP3_Unsupported_Stereo_Format": "This audio file is not in a supported mono format and can’t be uploaded. Try a different file.",
	"UploadAudio_Error_MP3_Unsupported_Format": "This audio file is not in a supported MP3 format and can’t be uploaded. Try a different file.",
	"UploadAudio_Error_aac_Unsupported_Format": "This audio file is not in a supported AAC format and can’t be uploaded. Try a different file,.",
	"UploadAudio_Error_wav_Unsupported_Format": "This audio file is not in a supported WAV format and can’t be uploaded. Try a different file.",
	"UploadAudio_Error_Unsupported_Sample_Size": "This file can't be uploaded. Try uploading a file with a sample size in 16/24/32 bit.",
	"UploadAudio_Error_Unsupported_Audio_Codec": "The {{codec}} audio codec used to make this file isn't supported and it can't be uploaded. Try a different file.",
	"UploadVideo_Error_MP4_Unsupported_Format": "This file is not in a supported MP4 format and can’t be uploaded. Try a different file.",
	"UploadVideo_Error_Unsupported_Sample_Rate": "This video file is not in a supported sample rate and can’t be uploaded. Try a different file.",
	"UploadVideo_Error_Unsupported_Bit_Rate": "The video bit rate {{fps}} is too high and file can't be uploaded. Try a different file.",
	"UploadVideo_Error_Video_Audio_Duration_Mismatch": "The file's video length {{videoDuration}} & audio length {{audioDuration}} don't match. Upload the file again.",
	"UploadVideo_Error_Unsupported_Video_Codec": "The {{codec}} video codec used to make this file isn't supported and it can't be uploaded. Try a different file.",
	"UploadVideo_Error_Video_Duration_SiteOwner": "This video exceeds your {{limit}} minute video limit. To upload this video, <1>upgrade now</1>.",
	"UploadVideo_Error_Video_Duration_Visitor": "This video can’t be uploaded right now. Contact the site owner for more information.",
	"UploadVideo_Error_StorageExceeded_Visitor": "Videos can't be uploaded right now. Contact the site owner for more information.",
	"UploadVideo_Error_StorageExceeded_SiteOwner": "You've exceeded your site's video hours limit. To save more videos on your site, <1>upgrade now</1>.",
	"Embed_Vertical_Stores_EmptyState_NoResults_Title": "No products found",
	"Embed_Vertical_Stores_EmptyState_NoResults_Description": "Try another search term.",
	"Embed_Vertical_Bookings_EmptyState_NoResults_Title": "No services found",
	"Embed_Vertical_Bookings_EmptyState_NoResults_Description": "Try another search term.",
	"Embed_Vertical_Events_EmptyState_NoResults_Title": "No events found",
	"Embed_Vertical_Events_EmptyState_NoResults_Description": "Try another search term.",
	"Embed_Vertical_Stores_EmptyState_NotInstalled_Title": "Add Wix Stores to your site",
	"Embed_Vertical_Stores_EmptyState_NotInstalled_Description": "To sell products online and share them in your post, go to the app market on your site and install Wix Stores.",
	"Embed_Vertical_Bookings_EmptyState_NotInstalled_Title": "Add Wix Bookings to your site",
	"Embed_Vertical_Bookings_EmptyState_NotInstalled_Description": "To sell services and share them in your post, go to the app market on your site and install Wix Bookings.",
	"Embed_Vertical_Events_EmptyState_NotInstalled_Title": "Add Wix Events to your site",
	"Embed_Vertical_Events_EmptyState_NotInstalled_Description": "To host events and share them in your post, go to the app market on your site and install Wix Events.",
	"Embed_Vertical_Stores_EmptyState_NoItems_Title": "No products for sale",
	"Embed_Vertical_Stores_EmptyState_NoItems_Description": "There are no products listed for sale at the moment.",
	"Embed_Vertical_Bookings_EmptyState_NoItems_Title": "No services available",
	"Embed_Vertical_Bookings_EmptyState_NoItems_Description": "There are no services on offer at the moment.",
	"Embed_Vertical_Events_EmptyState_NoItems_Title": "No upcoming events",
	"Embed_Vertical_Events_EmptyState_NoItems_Description": "There are no events scheduled at the moment.",
	"Embed_Vertical_Stores_Title": "Add a Product",
	"Embed_Vertical_Stores_Placeholder": "Search for a product",
	"Embed_Vertical_Stores_Search_Placeholder": "Search for a product",
	"Embed_Vertical_Bookings_Title": "Add a Service",
	"Embed_Vertical_Bookings_Placeholder": "Select a service from the list",
	"Embed_Vertical_Bookings_Search_Placeholder": "Search for a service",
	"Embed_Vertical_Events_Title": "Add an Event",
	"Embed_Vertical_Events_Search_Placeholder": "Search for an event",
	"Embed_Vertical_Events_Placeholder": "Select an event from the list",
	"Embed_Vertical_Nothing_Selected_Error_Title": "Nothing is selected",
	"Embed_Vertical_Nothing_Selected_Error_Description": "Please select an item to add, or press cancel.",
	"Embed_Vertical_Close_Button": "Close",
	"Embed_Vertical_Add_Button": "Add",
	"TablePlugin_MobileHeader": "Table",
	"TablePlugin_InsertButton": "Table",
	"Table_plugin_search_tags": "table grid row column data",
	"TablePlugin_InsertButton_Tooltip": "Add a table",
	"TablePlugin_PluginMenu_Tooltip": "Add plugins",
	"TablePlugin_Toolbar_TextStyle_Button": "Text style",
	"TablePlugin_Toolbar_GoBack_Button": "Go back",
	"TablePlugin_Toolbar_DeleteTable_Tooltip": "Delete table",
	"TablePlugin_Toolbar_Header_Tooltip": "Set as header",
	"TablePlugin_Toolbar_BGColor_Tooltip": "Background color",
	"TablePlugin_Toolbar_BorderColor_Tooltip": "Border color",
	"TablePlugin_Toolbar_Border_Color": "Border",
	"TablePlugin_Toolbar_VerticalAlignment_AlignTop_Tooltip": "Align top",
	"TablePlugin_Toolbar_VerticalAlignment_AlignMiddle_Tooltip": "Align middle",
	"TablePlugin_Toolbar_VerticalAlignment_AlignBottom_Tooltip": "Align bottom",
	"TablePlugin_Toolbar_VerticalAlignment_Tooltip": "Vertical alignment",
	"TablePlugin_Toolbar_ContextMenu_SplitCells_Button": "Split cells",
	"TablePlugin_Toolbar_ContextMenu_SelectRow_Button": "Select row",
	"TablePlugin_Toolbar_ContextMenu_SelectCol_Button": "Select column",
	"TablePlugin_Toolbar_ContextMenu_DeleteRow_Button": "Delete row",
	"TablePlugin_Toolbar_ContextMenu_InsertRow_Button": "Insert row",
	"TablePlugin_Toolbar_ContextMenu_InsertCol_Button": "Insert column",
	"TablePlugin_Toolbar_ContextMenu_InsertAbove_Button": "Insert 1 above",
	"TablePlugin_Toolbar_ContextMenu_InsertBelow_Button": "Insert 1 below",
	"TablePlugin_Toolbar_ContextMenu_DeleteCol_Button": "Delete column",
	"TablePlugin_Toolbar_ContextMenu_InsertRight_Button": "Insert 1 right",
	"TablePlugin_Toolbar_ContextMenu_InsertLeft_Button": "Insert 1 left",
	"TablePlugin_Toolbar_ContextMenu_DistributeRows_Button": "Distribute rows",
	"TablePlugin_Toolbar_ContextMenu_DistributeCols_Button": "Distribute columns",
	"TablePlugin_Toolbar_ContextMenu_MergeCells_Button": "Merge cells",
	"TablePlugin_Toolbar_ContextMenu_Clear_Button": "Clear",
	"TablePlugin_Toolbar_ContextMenu_DeleteTable_Button": "Delete table",
	"TablePlugin_SettingsModal_Title": "Add a table",
	"TablePlugin_SettingsModal_SubTitle": "Set the number of columns & rows",
	"TablePlugin_SettingsModal_ColCount": "Columns",
	"TablePlugin_SettingsModal_ErrorMessage": "There should be at least one row or column",
	"TablePlugin_SettingsModal_limitError": "Can’t add more than 100 cells",
	"TablePlugin_SettingsModal_RowCount": "Rows",
	"TablePlugin_SettingsModal_CreateTable_Button": "Add",
	"UnsupportedPlugin_message": "This content block can only be edited from a browser",
	"LinkPanel_Sponsored_Checkbox_Tooltip": "Let search engines know this link represents a paid ad, sponsorship, or paid agreement.",
	"Poll_plugin_search_tags": "vote ballot survey question ask interview opinion polls",
	"CollapsibleList_plugin_search_tags": "collapsible FAQ questions expandable sections menu Q&A listings items answers layouts",
	"ShortcutsSheet_Section_General": "General",
	"ShortcutsSheet_Section_ToolbarNavigation": "Toolbar Navigation",
	"ShortcutsSheet_Section_Formatting": "Text Formatting",
	"ShortcutsSheet_Section_BlocksMenu": "Blocks Menu",
	"ShortcutsSheet_Section_Table": "Table",
	"ShortcutsSheet_Section_CollapsibleList": "Expandable List",
	"ShortcutsSheet_General_AddHorizontalTabulation": "Add horizontal tabulation",
	"ShortcutsSheet_General_SelectTheNextBlock": "Select the next block",
	"ShortcutsSheet_General_Undo": "Undo",
	"ShortcutsSheet_General_Redo": "Redo",
	"ShortcutsSheet_General_SelectThePreviousBlock": "Select the previous block",
	"ShortcutsSheet_General_MoveSelectionThroughAllElements": "Move selection through all elements (text & blocks)",
	"ShortcutsSheet_General_OpenBlocksMenu": "Open blocks menu",
	"ShortcutsSheet_General_OpenKeyboardShortcutsSheet": "Open keyboard shortcuts sheet",
	"ShortcutsSheet_General_SelectAll": "Select all",
	"ShortcutsSheet_General_SelectTextBlocks": "Select text/blocks",
	"ShortcutsSheet_General_ClearSelection": "Clear selection",
	"ShortcutsSheet_General_MoveSelectedBlockUp": "Move selected block up",
	"ShortcutsSheet_General_MoveSelectedBlockDown": "Move selected block down",
	"ShortcutsSheet_ToolbarNavigation_EnterToolbar": "Enter toolbar",
	"ShortcutsSheet_ToolbarNavigation_MoveSelectionToTheNextOption": "Move selection to the next option",
	"ShortcutsSheet_ToolbarNavigation_MoveSelectionToThePreviousOption": "Move selection to the previous option",
	"ShortcutsSheet_ToolbarNavigation_ApplyASelection": "Apply a selection",
	"ShortcutsSheet_ToolbarNavigation_ExitToolbar": "Exit toolbar",
	"ShortcutsSheet_Formatting_ParagraphFormat": "Paragraph format",
	"ShortcutsSheet_Formatting_Heading1": "Heading 1",
	"ShortcutsSheet_Formatting_Heading2": "Heading 2",
	"ShortcutsSheet_Formatting_Heading3": "Heading 3",
	"ShortcutsSheet_Formatting_Heading4": "Heading 4",
	"ShortcutsSheet_Formatting_Heading5": "Heading 5",
	"ShortcutsSheet_Formatting_Heading6": "Heading 6",
	"ShortcutsSheet_Formatting_IncreaseFontSize": "Increase Font Size",
	"ShortcutsSheet_Formatting_DecreaseFontSize": "Decrease Font Size",
	"ShortcutsSheet_Formatting_IncreaseIndent": "Increase Indent",
	"ShortcutsSheet_Formatting_DecreaseIndent": "Decrease Indent",
	"ShortcutsSheet_Formatting_AlignLeft": "Align Left",
	"ShortcutsSheet_Formatting_AlignRight": "Align Right",
	"ShortcutsSheet_Formatting_AlignCenter": "Align Center",
	"ShortcutsSheet_Formatting_Justify": "Justify",
	"ShortcutsSheet_Formatting_Bold": "Bold ",
	"ShortcutsSheet_Formatting_Italic": "Italic",
	"ShortcutsSheet_Formatting_Underline": "Underline",
	"ShortcutsSheet_Formatting_NumberedList": "Numbered List",
	"ShortcutsSheet_Formatting_BulletedList": "Bulleted List",
	"ShortcutsSheet_Formatting_Quote": "Quote",
	"ShortcutsSheet_Formatting_Link": "Link",
	"ShortcutsSheet_Formatting_CodeBlock": "Code block",
	"ShortcutsSheet_Formatting_PasteWithoutFormatting": "Paste without formatting",
	"ShortcutsSheet_Formatting_SoftNewLine": "Soft New Line",
	"ShortcutsSheet_Formatting_NewLine": "New Line",
	"ShortcutsSheet_BlocksMenu_OpenBlocksMenu": "Open blocks menu",
	"ShortcutsSheet_BlocksMenu_SelectTheNextBlock": "Select the next block",
	"ShortcutsSheet_BlocksMenu_ApplyASelection": "Apply a selection",
	"ShortcutsSheet_BlocksMenu_ExitBlocksMenu": "Exit blocks menu",
	"ShortcutsSheet_Table_MoveToTheNextCell": "Move to the next cell",
	"ShortcutsSheet_Table_MoveToThePreviousCell": "Move to the previous cell",
	"ShortcutsSheet_Table_EnterExitASelectedCell": "Enter/exit a selected cell",
	"ShortcutsSheet_Table_AddANewLineWithinCell": "Add a new line within cell",
	"ShortcutsSheet_Table_DroppingLineWithinAList": "Dropping line within a list",
	"ShortcutsSheet_Table_SelectingAllContentInsideCell": "Selecting all content inside cell",
	"ShortcutsSheet_Table_SelectColumn": "Select column",
	"ShortcutsSheet_Table_SelectRow": "Select row",
	"ShortcutsSheet_Table_SelectTable": "Select table",
	"ShortcutsSheet_Table_AddNewColumnRow": "Add new column/row (after selected column/row)",
	"ShortcutsSheet_Table_DeleteSelectedColumnRow": "Delete selected column/row",
	"ShortcutsSheet_CollapsibleList_MoveToNextElement": "Move to next element",
	"ShortcutsSheet_CollapsibleList_SelectAllContentWithinSection": "Select all content within section",
	"ShortcutsSheet_CollapsibleList_SelectTheEntireList": "Select the entire list",
	"ShortcutsSheet_Title": "Keyboard Shortcuts",
	"Plugin_Rendering_Error": "Can't display this piece of content. Delete this element and try adding it again.",
	"AIPlugin_Flow_ContentAssistant": "AI Content Assistant",
	"AIPlugin_Flow_ImageGenerator": "AI Image Generator",
	"AIPlugin_Modal_ImageGeneratorTitle": "AI Image",
	"AIPlugin_Loading_Initialising": "Restructuring into a prompt for maximum quality...",
	"AIPlugin_Loading_GenerateImage": "Generating the image...",
	"AIPlugin_Helper_GenerateImage_Optimise": "To maximize quality, we’ve restructured your paragraph in the prompt. Review the updated prompt and select ‘Generate’ to create your image.",
	"AIPlugin_Helper_GenerateImage_Button": "Got It",
	"AIPlugin_Modal_Title": "Content AI",
	"AIPlugin_FeedLabel_You": "You",
	"AIPlugin_FeedLabel_Assistant": "Content AI",
	"AIPlugin_Input_Placeholder_Text": "E.g.,  Make it funny, write a poem about spring, etc.",
	"AIPlugin_Input_ImageGeneratePlaceholder_Text": "Describe your vision... (e.g. 'A sunset over mountain peaks' or 'A futuristic city skyline at night')",
	"AIPlugin_Input_Loading_Text": "Creating text...",
	"AIPlugin_Button_Stop_Text": "Stop",
	"AIPlugin_Characters_Tooltip_Text": "{{count}} out of {{limit}} characters",
	"AIPlugin_Characters_Completed_Tooltip_Text": "You’ve reached the {{limit}} character limit",
	"AIPlugin_Error_Title": "Couldn’t process your request",
	"AIPlugin_Error_Text": "There was a technical issue on our end. Refresh the page and retry or try again in a few minutes.",
	"AIPlugin_Error_Button_GoBack": "Go Back",
	"AIPlugin_Error_Button_Retry": "Retry",
	"AIPlugin_NoSelection_Title": "Create or tweak content",
	"AIPlugin_NoSelection_Text": "Use the field to describe what text you want to create. You can also select what you already wrote and ask the AI to tweak it.",
	"AIPlugin_Prompt_GenerateCaption": "Caption",
	"AIPlugin_Prompt_GenerateAltText": "Generate alt text",
	"AIPlugin_Prompt_ChangeTone_Professional": "Professional",
	"AIPlugin_Prompt_ChangeTone_Casual": "Casual",
	"AIPlugin_Prompt_ChangeTone_Friendly": "Friendly",
	"AIPlugin_Prompt_ChangeTone_Funny": "Funny",
	"AIPlugin_Prompt_ChangeTone_Confident": "Confident",
	"AIPlugin_Prompt_ChangeTone_Enthusiastic": "Enthusiastic",
	"AIPlugin_Prompt_Summarize": "Summarize",
	"AIPlugin_Prompt_GenerateHeading": "Create a heading",
	"AIPlugin_Prompt_Rephrase": "Rephrase",
	"AIPlugin_Prompt_FixSpellingAndGrammar": "Fix spelling & grammar",
	"AIPlugin_Prompt_MakeShorter": "Shorten",
	"AIPlugin_Prompt_MakeLonger": "Expand",
	"AIPlugin_Prompts_Section_Adjust": "Adjust",
	"AIPlugin_Prompts_Section_Generate": "Create content",
	"AIPlugin_Prompts_Section_ChangeTone": "Change tone",
	"AIPlugin_Action_WritePrompt": "Tweak with prompt",
	"AIPlugin_Prompts_Section_Image": "Image",
	"AIPlugin_Action_GenerateImage": "Turn text into image",
	"AIPlugin_PromptsList_Confirm_Suffix": "Enter",
	"AIPlugin_Action_Copy": "Copy to clipboard",
	"AIPlugin_Action_Replace": "Replace Text",
	"AIPlugin_Action_InsertBelow": "Insert Below",
	"AIPlugin_Action_InsertAbove": "Insert Above",
	"AIPlugin_Action_Insert": "Insert",
	"AIPlugin_Action_Generate": "Generate",
	"AIPlugin_Action_Regenerate": "Regenerate",
	"AIPlugin_Action_StopGenerating": "Stop Generating",
	"AIPlugin_Actions_Section_Modify": "Adjust",
	"AIPlugin_Actions_Section_ChangeTone": "Change tone",
	"AIPlugin_ToolbarButton_Text": "Content AI",
	"AIPlugin_ToolbarButton_Tooltip": "Content AI",
	"AIPlugin_Placeholder": "Write something or press Space for Content AI",
	"AIPlugin_HistoryPagination_Text": "{{currentPage}}/{{totalPages}}",
	"AIPlugin_ResultsDisclaimer_Text": "AI can make mistakes, so double-check that the results are accurate before using them.",
	"AIPlugin_DiscardModal_PrimaryButton_Text": "Discard",
	"AIPlugin_DiscardModal_SecondaryButton_Text": "Cancel",
	"AIPlugin_DiscardModal_Title": "Discard results?",
	"AIPlugin_DiscardModal_Content": "Closing the AI will discard its result history. If you want to keep any of the created content, insert it before closing.",
	"AIPlugin_DiscardModal_DontShowAgain": "Don’t show this again",
	"AIPlugin_ImagePlugin_Input_Placeholder_Text": "E.g., Small factory. Built in 1788. (Optional)",
	"AIPlugin_ImagePlugin_AltText_Generate_Text": "Generate with AI",
	"AIPlugin_ImagePlugin_AltText_InProgress": "Creating text...",
	"AIPlugin_ImagePlugin_NoSelection_Title": "Generate a caption for your image",
	"AIPlugin_ImagePlugin_NoSelection_Text": "Image captions help provide additional information about an image that is not seen in the image.\n\nProvide context for the Content AI to use or let it generate the caption by simply analyzing the image.",
	"AIPlugin_Prompt_GenerateAltText_Error": "An error occurred while generating your alt text. Please try again.",
	"AIPlugin_Label_ImageStyle": "Image Style",
	"AIPlugin_ImageStyle_None": "None",
	"AIPlugin_ImageStyle_Photography": "Photography",
	"AIPlugin_ImageStyle_DigitalArt": "Digital art",
	"AIPlugin_ImageStyle_Fantasy": "Fantasy",
	"AIPlugin_ImageStyle_Sketch": "Sketch",
	"AIPlugin_ImageStyle_Cinematic": "Cinematic",
	"AIPlugin_ImageStyle_ComicBook": "Comic book",
	"AIPlugin_ImageStyle_NeonPunk": "Neon punk",
	"AIPlugin_ImageStyle_3D": "3D",
	"AIPlugin_ImageStyle_LowPoly": "Low-poly",
	"AIPlugin_ImageStyle_Anime": "Anime",
	"AIPlugin_ImageStyle_Isometric": "Isometric",
	"AIPlugin_ImageInsertError_Position": "An error occurred while inserting the image in the selected content. Select a different place to insert the image or try again.",
	"Editor_KeyboardNavigation_Tooltip": "Use arrow keys to navigate content, press Esc to exit editor.",
	"QuickActionsPlugin_EditorPlaceholder": "Start writing or type / for plugins",
	"QuickActionsPlugin_SectionTitle_CommonlyUsed": "Commonly Used",
	"QuickActionsPlugin_SectionTitle_AI": "AI",
	"QuickActionsPlugin_SectionTitle_FormatLayout": "Format & Layout",
	"QuickActionsPlugin_SectionTitle_Media": "Media",
	"QuickActionsPlugin_SectionTitle_Embed": "Embed",
	"QuickActionsPlugin_SectionTitle_EmbedFromWIX": "Embed from Wix",
	"QuickActionsPlugin_ActionTitle_WriteWithAI": "Write with AI",
	"QuickActionsPlugin_ActionTitle_CreateImageWithAI": "Create image with AI",
	"QuickActionsPlugin_ActionTitle_HeadingOne": "Heading 1",
	"QuickActionsPlugin_ActionTitle_HeadingTwo": "Heading 2",
	"QuickActionsPlugin_ActionTitle_HeadingThree": "Heading 3",
	"QuickActionsPlugin_ActionTitle_Quote": "Quote",
	"QuickActionsPlugin_ActionTitle_CodeSnippet": "Code snippet",
	"QuickActionsPlugin_ActionTitle_NumberedList": "Numbered list",
	"QuickActionsPlugin_ActionTitle_BulletedList": "Bulleted list",
	"QuickActionsPlugin_ActionTitle_ExpandableList": "Expandable list",
	"QuickActionsPlugin_ActionTitle_Link": "Link",
	"QuickActionsPlugin_ActionTitle_Button": "Button",
	"QuickActionsPlugin_ActionTitle_Emoji": "Emoji",
	"QuickActionsPlugin_ActionTitle_Divider": "Divider",
	"QuickActionsPlugin_ActionTitle_Poll": "Poll",
	"QuickActionsPlugin_ActionTitle_Table": "Table",
	"QuickActionsPlugin_ActionTitle_TwoColumns": "2 Columns",
	"QuickActionsPlugin_ActionTitle_ThreeColumns": "3 Columns",
	"QuickActionsPlugin_ActionTitle_Image": "Image",
	"QuickActionsPlugin_ActionTitle_Gallery": "Gallery",
	"QuickActionsPlugin_ActionTitle_Video": "Video",
	"QuickActionsPlugin_ActionTitle_GIF": "GIF",
	"QuickActionsPlugin_ActionTitle_File": "File",
	"QuickActionsPlugin_ActionTitle_AudioFile": "Audio file",
	"QuickActionsPlugin_ActionTitle_SoundCloud": "SoundCloud",
	"QuickActionsPlugin_ActionTitle_YoutubeVideo": "YouTube video",
	"QuickActionsPlugin_ActionTitle_InstagramPost": "Instagram post",
	"QuickActionsPlugin_ActionTitle_TikTokVideo": "TikTok video",
	"QuickActionsPlugin_ActionTitle_SpotifyTrack": "Spotify track",
	"QuickActionsPlugin_ActionTitle_XPost": "X post",
	"QuickActionsPlugin_ActionTitle_AdSense": "AdSense",
	"QuickActionsPlugin_ActionTitle_HtmlEmbed": "HTML Embed",
	"QuickActionsPlugin_ActionTitle_Product": "Product",
	"QuickActionsPlugin_ActionTitle_Event": "Event",
	"QuickActionsPlugin_ActionTitle_Service": "Service",
	"QuickActionsPlugin_AddButton_AriaLabel": "Open quick actions menu",
	"PluginSettingsPanel_DiscardModal_PrimaryButton_Text": "Discard Changes",
	"PluginSettingsPanel_DiscardModal_SecondaryButton_Text": "Cancel",
	"PluginSettingsPanel_DiscardModal_Title": "Discard changes?",
	"PluginSettingsPanel_DiscardModal_Content": "You’ve made some changes for this plugin, do you want to discard them and continue?",
	"Layouts_CellAddLeft_Tooltip": "Add column to left",
	"Layouts_CellAddRight_Tooltip": "Add column to right",
	"Layouts_CellDelete_Tooltip": "Delete column",
	"Layouts_CellMoveLeft_Tooltip": "Move column to left",
	"Layouts_CellMoveRight_Tooltip": "Move column to left",
	"Layouts_LayoutDelete_Tooltip": "Delete layout",
	"Layout_InsertButton_Tooltip": "Columns",
	"Layout_InsertModal_Header_Title": "Columns",
	"Layout_InsertModal_2Columns": "2 Columns",
	"Layout_InsertModal_3Columns": "3 Columns",
	"Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person voted for this answer",
	"Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} people voted for this answer",
	"Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymous",
	"Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
	"Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Follow",
	"Poll_Viewer_ShowAllOptions_CTA": "See All Options",
	"Poll_Viewer_ShowAllResults_CTA": "See All Results",
	"Poll_Viewer_ShowLess_CTA": "Show Less",
	"Poll_Viewer_Visibility_Owner_Footer": "Only you can see the results.",
	"Poll_Viewer_Multiselect_Footer": "You can vote for more than one answer.",
	"Poll_Viewer_Toast_Error_Connection": "No internet. Check your connection.",
	"Poll_Viewer_Toast_Error_ServerDown": "Couldn't connect to server. Try again later.",
	"Poll_Viewer_VoteCount": "{{number}} votes",
	"Poll_Viewer_Option_AriaLabel_Checked": "checked",
	"Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
	"Audio_Plugin_Cover_Alt": "Audio cover",
	"Polls_Plugin_User_Avatar_Alt": "User avatar",
	"UploadFile_Viewer_Download": "Download {{fileType}}",
	"UploadFile_Viewer_Loader": "Loading {{fileType}}",
	"Viewer_Toolbar_Twitter_Tooltip": "Tweet this",
	"Preview_ReadMore_Label": "Read more",
	"Preview_SeeFullPost_Label": "See Full Post",
	"Spoiler_Reveal_Tooltip": "Click to reveal",
	"Spoiler_Reveal_Image_Placeholder": "This image contains a spoiler",
	"Spoiler_Reveal_Image_CTA": "Reveal Image",
	"Spoiler_Reveal_Gallery_Placeholder": "This gallery contains a spoiler",
	"Spoiler_Reveal_Gallery_CTA": "Reveal Gallery",
	"Spoiler_Reveal_Video_Placeholder": "This video contains a spoiler",
	"Spoiler_Reveal_Video_CTA": "Reveal Video",
	"CollapsibleListPlugin_ExpandButton_AriaLabel": "Item is expanded",
	"CollapsibleListPlugin_CollapseButton_AriaLabel": "Item is collapsed",
	"VerticalEmbed_Bookings_Button": "Book Now",
	"VerticalEmbed_Events_Button": "Register Now",
	"VerticalEmbed_Products_Button": "Buy Now",
	"VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
	"VerticalEmbed_Units_Hour": "{{hours}}h",
	"VerticalEmbed_Units_Minute": "{{minutes}}min",
	"Image_Expand_Button_AriaLabel": "Expand image",
	"Fullscreen_Close_Button_AriaLabel": "Close",
	"Fullscreen_Expand_Button_AriaLabel": "Expand",
	"Fullscreen_Shrink_Button_AriaLabel": "Shrink"
}